import type { RouteProps } from '../../util';
import { route } from 'preact-router';
import { LoginPage } from '../components';


const handleLogIn = () => route('/');

export const LoginRoute = (_: RouteProps) => <LoginPage onLogIn={ handleLogIn }/>;